<template>
  <Tooltip placement="top" :content="tooltipContent" :disabled="disableTooltip" max-width="400" transfer>
    <div class="avatar" v-bind:style="style" @click="$emit('click')">
      <slot></slot>
      <table>
        <tr>
          <td v-if="!hasImage">{{ initials }}</td>
        </tr>
      </table>
    </div>
  </Tooltip>
</template>

<script>
export default {
  name: "UserAvatar",
  props: {
    fullname: { type: String, default: "##" },
    email: { type: String, default: "" },
    size: { type: Number, default: 48 },
    radius: {
      type: Number,
      default: 50,
      validator: (value) => value >= 0 && value <= 50,
    },
    color: { type: String, default: "" },
    image: { type: String, default: "" },
    initialized: { type: Boolean, default: true },
    disableTooltip: { type: Boolean, default: false },
  },
  computed: {
    // compute initials from fullname
    tooltipContent() {
      return `${this.fullname}${this.email === null || this.email === "" ? "" : " : " + this.email}`;
    },
    initials() {
      if (this.initialized === false) {
        return this.fullname;
      }

      if (!this.fullname) {
        return "";
      }

      let words = this.fullname.split(/[\s-]+/);
      let intls = "";
      for (var i = 0; i < words.length; i++) {
        intls += words[i].substr(0, 1).toUpperCase();
      }
      if (intls.length > 3) {
        intls = intls.substr(0, 3);
      }
      return intls;
    },
    // compute style from props
    style() {
      let fontSize = this.initials.length > 2 ? (this.size - 8) / 3 : (this.size - 8) / 2;
      return {
        width: this.size + "px",
        height: this.size + "px",
        "border-radius": this.radius + "%",
        "font-size": fontSize + "px",
        "background-color": this.color === "" ? this.toColor(this.fullname) : this.color,
        "background-image": this.hasImage ? "url(" + this.image + ")" : "none",
      };
    },
    hasImage() {
      return this.image !== "" && this.image !== null;
    },
  },
  methods: {
    toColor(str) {
      if (!str) {
        return "black";
      }

      let hash = 0;
      let len = str.length;
      if (len === 0) return "black";
      for (var i = 0; i < len; i++) {
        hash = (hash << 8) - hash + str.charCodeAt(i);
        hash |= 0;
      }
      hash = Math.abs(hash);

      return "#" + hash.toString(16).substr(0, 6);
    },
  },
};
</script>

<style scoped>
.avatar {
  display: inline-block;
  background-color: black;
  color: white;
  width: 48px;
  height: 48px;
  font-size: 12px;
  line-height: 24px;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: none;
}
.avatar table {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
.avatar table td {
  text-align: center;
  vertical-align: middle;
  width: 100%;
  height: 100%;
  background-color: transparent;
  border-bottom: 0;
}
.avatar img {
  width: 100%;
  overflow: hidden;
}
</style>
